module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "permission-header"
  }, [_c('v-app-bar', {
    attrs: {
      "dark": "",
      "dense": "",
      "color": "#32383f"
    }
  }, [_c('div', {
    staticClass: "admin__header-nav__dashboard",
    on: {
      "click": _vm.navigateToDashboard
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "color": "#C6CCD0"
    }
  }, [_vm._v("mdi-view-dashboard")]), _vm._v(" "), _c('div', {
    staticClass: "admin__header-nav__dashboard_label text-button"
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('div', {
    staticClass: "admin__header-nav__dashboard_label text-button pl-3"
  }, [_vm._v("Admin Management")])]), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "dark": "",
      "dense": "",
      "color": "#32383f"
    }
  }, [_c('v-tabs', {
    attrs: {
      "background-color": "#32383f",
      "dark": ""
    }
  }, _vm._l((_vm.routes), function(route) {
    return _c('v-tab', {
      key: route.name,
      attrs: {
        "to": route.path
      }
    }, [_vm._v("\n        " + _vm._s(route.name) + "\n      ")])
  }), 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a525320"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/permissions/components/Header.vue
// module id = 1864
// module chunks = 0